import React from 'react';
import './News.css';

const News = ({ currentLanguage }) => {
  const getTranslation = (key) => {
    const translations = {
      en: {
        title: 'Newspaper Features',
        subtitle: 'Featured in local newspapers and media coverage'
      },
      hi: {
        title: 'समाचारपत्र विशेषताएं',
        subtitle: 'स्थानीय समाचारपत्रों और मीडिया कवरेज में प्रदर्शित'
      },
      gu: {
        title: 'અખબારની વિશેષતાઓ',
        subtitle: 'સ્થાનિક અખબારો અને મીડિયા કવરેજમાં દર્શાવવામાં આવ્યું'
      }
    };
    return translations[currentLanguage]?.[key] || translations.en[key];
  };

  const newsImages = [
    '/images/News/n1.jpeg',
    '/images/News/n2.jpeg',
    '/images/News/n3.jpeg',
    '/images/News/n4.jpeg'
  ];

  return (
    <section id="news" className="news">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{getTranslation('title')}</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">{getTranslation('subtitle')}</p>
        </div>
        <div className="news-grid">
          {newsImages.map((image, index) => (
            <div key={index} className="news-card">
              <div className="news-image">
                <img src={image} alt={`News Update ${index + 1}`} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default News;